export default {
  barmessage: {
    Home: '首页',
    data: '数据检索',
    About: '关于',
    productService: 'product service',
    cases: 'solution',
    news: 'news',
    contactUs: 'contact us',
    login: '登陆',
    report: '信息统计',
    LOGOtitle:'ບໍ່ລິການ ຂໍ້ມູນ'
  },
  //查询面板
  queryboardmessage: {
    polygon: '多边形',
    nominatim: '输入地名',
    producttype: '产品等级',
    cloud: '云量 <',
    sensing: '拍摄日期',
    satellite: '卫星传感器:',
    drawpolygon: '画多边形',
    drawrectangle: '画矩形',
    clear: '清除区域条件',
    query: '数据检索',
    cart: '显示/隐藏购物车',
    togglebutton: '切换查询面板',
    uploadfailed: '不支持的数据格式',
    uploadsuccessed: '上传矢量数据成功',
    uploadbutton: '上传文件',
    uploadtitle: '矢量上传',
    upoladtip: '支持shp文件（.zip文件，包括.dbf，.shp，.prj三类文件，文件名需为英文）'
  },
  querymapmessage: { //查询底图上的文字
    lonlat: '经度 纬度:',
    fullscreen: '切换全屏',
    owslayername: 'OSM底图',
    satellitelayername: '遥感影像底图'
  },
  resultlistmessage: {
    satellite: '卫星',
    sensingdate: '拍摄日期',
    online: '在线',
    offline: '离线',
    display: '显示{count} 条数据中第{startindex}条到第{endindex}条',
    cartdisplay: '购物车中包含{ itemcount }条数据.',
    nofound: '没有找到产品',
    viewdata: '查看数据详细信息',
    zoomtodata: '定位到数据',
    downloaddata: '数据下载',
    tocart: '数据加入到购物车',
    removecart: '从购物车移除',
    offlinewaring: '数据已离线'
  },
  userprofilemessage: {
    edit: '编辑用户信息',
    logout: '退出登录',
    function: '具备的功能',
    download: '数据下载',
    search: '数据检索'
  },
  fpmessage: {
    // 忘记密码
    title: '忘记密码',
    mess: '请填写此表格以接收允许您设置新密码的链接。',
    username: '用户名',
    usernameempty: '用户名空',
    emailvalid: "电子邮件格式不正确",
    email: '电子邮件',
    send: '发送',
    errtitle: '密码取回错误',
    errmess: '找不到此用户名/电子邮件组合的用户',
    succtitle: '找回密码成功',
    succmess: '一封电子邮件已发送给您，其中包含重置密码的说明。'
  },
  rpmessage: { //重置密码面板
    title: '重置密码',
    mess: '请填写此表格以重置您的密码。',
    passwdrule: ' 密码字段只接受字母数字字符加上“!”、“@”、“#”、“$”、“%”、“^”、“&”、“*”、“)”、“(”、“+” , "=", ".", "_", "-"。密码字段最小长度为 8 个字符。',
    passwd: '密码',
    emptypasswd: '空密码',
    passwdvalid: '密码太短。 最少 8 个字符',
    confirmpasswdvalid: '两次输入密码不匹配 ',
    confirmpasswd: '确认密码',
    send: '修改',
    mbtitle1: '密码重置',
    mbresult1: ' 您的密码被重置',
    mbresult2: ' 密码重置是发生了一个错误',
    mbtitle2: '密码重置失败'
  },
  registmessage: {
    title: '注册新用户',
    header1: '注册用户免费获取数据',
    notice1: ' 填写下面的注册表后，您将收到一封电子邮件，其中包含验证您的电子邮件地址的链接。 在此之后，您可以开始下载数据。 用户名字段仅接受小写字母数字字符加上“.”、“-”和“_”。 密码字段只接受字母数字字符加上“!”、“@”、“#”、“$”、“%”、“^”、“&”、“*”、“)”、“(”、“+” , "=", ".", "_", "-"。密码字段最小长度为 8 个字符',
    firstname: '姓',
    lastname: '名',
    username: '用户名',
    passwd: '密码',
    confirmpasswd: '确认密码',
    company: '公司/组织名称',
    email: '电子邮件地址',
    confirmemail: '确认电子邮件地址',
    emailcheck: '电子邮件地址格式错误',
    emailmatch: '电子邮件不匹配',
    selectdomain: '选择领域',
    selectusage: '选择用途',
    selectcountry: '选择国家',
    register: '注册',
    shouquan: '在本网站注册即视为您已接受 GF 数据使用条款和条件'
  },
  editprofilemessage: {
    title: '用户 {username} 配置',
    firstname: '姓',
    firstnameempty: '没有填写姓氏',
    lastnameempty: '没有填写名',
    lastname: '名',
    username: '用户名',
    passwd: '密码',
    confirmpasswd: '确认密码',
    company: '公司/组织名称',
    email: '电子邮件地址',
    confirmemail: '确认电子邮件地址',
    emailcheck: '电子邮件地址格式错误',
    emailmatch: '电子邮件不匹配',
    selectdomain: '选择领域',
    selectusage: '选择用途',
    selectcountry: '选择国家',
    passwordalerm1: '请输入密码',
    passwordalerm2: '密码长度太短，最少8个字符',
    oldpasswd: '输入旧密码',
    savemodification: '保存更改',
    passwdrule1: ' 密码字段只接受字母数字字符加上“!”、“@”、“#”、“$”、“%”、“^”、“&”、“*”、“)”、“(”、“+” , "=", ".", "_", "-"。',
    passwdrule2: ' 密码字段的最小长度为 8 个字符。',
    changepasswd: '修改密码'
  },
  loginmessage: {
    title: '请登录以访问我们的服务...',
    username: '用户名',
    passwd: '密码',
    loginbutton: '登陆',
    signup: '注册',
    fpasswd: '忘记密码?',
    passwordalerm1: '请输入密码',
    passwordalerm2: '密码长度太短，最少8个字符',
    passwderr: "您输入的用户名和密码不匹配或用户未激活。",
    loginsuccess: '登陆成功',
    logoutsuccess: '成功登出'
  },
  servicemessage: { //服务状态
    mess: '网站停止服务 '
  },
  downloadmessage: { //数据下载面板信息
    title: "数据详细信息",
    downloadmess: "下载产品",
    closemess: "关闭",
  },
  vdusermessage: { //激活用户
    title: '',
    success: '账号成功激活',
    failed: '账号激活失败'
  },
  reportmessage: {
    title: '自服务运营以来所有数据中心服务的统计信息',
    RUsers: '注册用户',
    download: '用户下载量',
    Productsnum: '已发布产品数量',
    Availability: '过去一个月的可用性'
  }
}